import { useMutation, UseMutationResult } from '@tanstack/react-query';

import { GetResponseDocumentRequest } from 'api';
import { getResponseDocument } from '../methods';
import { GetResponseDocumentResponse } from '../types';

export const useResponseDocument = (): UseMutationResult<
  GetResponseDocumentResponse,
  unknown,
  GetResponseDocumentRequest
> => useMutation(getResponseDocument);
